<!-- 
  填写输单原因
 -->

<template>
  <div class="loseCause">
    <el-dialog title="输单反馈" 
      :visible.sync="loseCauseShow"
      :modal-append-to-body="false"
      :before-close="close"
      top="22%"
      >
      <div class="warn" v-if="flag"><i class="el-icon-warning"></i>确认跳转到<span style="color:#F28B47">输单</span>阶段吗？</div>
      <div class="cause">
        <el-select v-model="curLoseCause" placeholder="选择输单原因（必填）">
          <el-option 
            v-for="option in loseCauseArray" 
            :label="option.value" 
            :key="option.key"
            :value="option.key"
            ></el-option>
        </el-select>
      </div>
      <div class="textarea">
        <el-input 
          type="textarea" 
          v-model="curLoseCauseMemo" 
          placeholder="输单备注"
          ></el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="handleSubmit">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as api from 'src/api'
import { Message } from 'element-ui'

export default {
  props: {
    oppId: {
      type: Number,
      required: true
    },
    loseCauseShow: Boolean,
    code: Number,
    nextCode: Number,
    flag: Boolean
  },
  data () {
    return {
      loseCauseArray: [], // 输单原因列表
      curLoseCause: '',
      curLoseCauseMemo: ''
    }
  },
  created () {
    this.getOpportunityCause()
  },
  methods: {
    getOpportunityCause () {
      let url = `/opportunityApi/loseCauseItem.html`
      let params = {
        oppId: this.oppId
      }
      api.post(url, params, (data) => {
        this.dialogVisible = true
        this.loseCauseArray = data.result.loseCauseArray
      })
    },
    handleSubmit () {
      if (!this.curLoseCause) {
        Message({
          type: 'error',
          message: '请选择输单原因'
        })
        return
      } else if (this.curLoseCauseMemo.length > 255) {
        Message({
          type: 'error',
          message: '输单备注字数超出最大限制'
        })
        return
      }
      if (this.flag) {
        let url = `/opportunityApi/changeStageSave.html`
        let params = {
          id: this.oppId,
          code: this.code || this.nextCode,
          loseCause: this.curLoseCause,
          memo: this.curLoseCauseMemo
        }
        api.post(url, params, (data) => {
          Message({
            type: 'success',
            message: data.msg || '跳转成功!'
          })
          this.$emit('close')
          this.$emit('refresh')
        })
      } else {
        let url = `/opportunityApi/loseCauseSave.html`
        let params = {
          oppId: this.oppId,
          loseCause: this.curLoseCause,
          memo: this.curLoseCauseMemo
        }
        api.post(url, params, (data) => {
          this.$emit('close')
          this.$emit('refresh')
        })
      }
    },
    close () {
      this.$emit('close')
    }
  },
  watch: {
    loseCauseShow (val) {
      if (!val) {
        this.$emit('close')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.loseCause {
  .warn{
    margin-bottom: 20px;
    height: 24px;
    line-height: 24px;
    i{
      color: #e6a23c;
      font-size: 20px;
      line-height: 26px;
      padding-right: 10px;
    }
  }
  .cause {
    margin-bottom: 20px;
    &:before {
      content: '*';
      color: red;
      margin-right: 5px;
    }
  }
  .textarea {
    margin-left: 13px;
    textarea {
      min-height: 100px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// lose-cause.vue?3733aa4c